import { useState } from 'react';
import { membershipService } from 'services/api';
import SearchableSelect from 'components/SearchableSelect';
import styles from './MembershipEditModal.module.css';

export default function MembershipEditModal({ property, onClose, onSaved }) {
  const [form, setForm]     = useState({
    subscription_status:     property.subscription_status || 'trial',
    subscription_expires_at: property.subscription_expires_at
      ? new Date(property.subscription_expires_at).toISOString().split('T')[0]
      : '',
  });
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState(null);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true); setError(null);
    try {
      await membershipService.update(property.id, {
        subscription_status:     form.subscription_status,
        subscription_expires_at: form.subscription_expires_at || null,
      });
      onSaved('Membresía actualizada correctamente');
    } catch (err) {
      setError(err.response?.data?.message || 'Error al guardar');
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${styles.caja}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h3><i className={`fas fa-id-card ${styles.iconoTitulo}`} />Editar membresía</h3>
            <div className={styles.subtitulo}>{property.name}</div>
          </div>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={save} noValidate>
          <div className={`modal-body ${styles.cuerpo}`}>
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="form-group">
              <label className="form-label">Estado de membresía</label>
              <SearchableSelect value={form.subscription_status} onChange={(v) => setForm(f => ({ ...f, subscription_status: v }))} minWidth={0} maxWidth={9999} allowEmpty={false} ariaLabel="Estado de membresía" options={[{ value: 'active', label: 'Activa' }, { value: 'trial', label: 'Trial' }, { value: 'inactive', label: 'Inactiva' }]} />
            </div>
            <div className="form-group">
              <label className="form-label">Fecha de vencimiento</label>
              <input type="date" className="form-control"
                value={form.subscription_expires_at}
                onChange={e => setForm(f => ({ ...f, subscription_expires_at: e.target.value }))} />
              <div className={styles.ayuda}>
                Dejar vacío = sin fecha de vencimiento
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? <><i className="fas fa-spinner fa-spin" /> Guardando...</> : <><i className="fas fa-save" /> Guardar</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
